export const POPUP_CONTENT_QUERY_KEY = 'popup_content';
export const ENROLLMENT_CONTEXT_NONE = 'none';
